// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressController from "./address_controller"
application.register("address", AddressController)

import AttachmentsController from "./attachments_controller"
application.register("attachments", AttachmentsController)

import CheckboxToggleController from "./checkbox_toggle_controller"
application.register("checkbox-toggle", CheckboxToggleController)

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import CommentLinkController from "./comment_link_controller"
application.register("comment-link", CommentLinkController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import ConsumerFormController from "./consumer_form_controller"
application.register("consumer-form", ConsumerFormController)

import ConsumerSummaryController from "./consumer_summary_controller"
application.register("consumer-summary", ConsumerSummaryController)

import ContractApplications__StampTaxEditController from "./contract_applications/stamp_tax_edit_controller"
application.register("contract-applications--stamp-tax-edit", ContractApplications__StampTaxEditController)

import CopyLinkController from "./copy_link_controller"
application.register("copy-link", CopyLinkController)

import DownloadQrcodeController from "./download_qrcode_controller"
application.register("download-qrcode", DownloadQrcodeController)

import DatePicker__DateController from "./date_picker/date_controller"
application.register("date-picker--date", DatePicker__DateController)

import DatePicker__DateRangeController from "./date_picker/date_range_controller"
application.register("date-picker--date-range", DatePicker__DateRangeController)

import DatePicker__DatetimeController from "./date_picker/datetime_controller"
application.register("date-picker--datetime", DatePicker__DatetimeController)

import DatePicker__MonthController from "./date_picker/month_controller"
application.register("date-picker--month", DatePicker__MonthController)

import DragulaController from "./dragula_controller"
application.register("dragula", DragulaController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import FeedbackItemsController from "./feedback_items_controller"
application.register("feedback-items", FeedbackItemsController)

import FormItemsController from "./form_items_controller"
application.register("form-items", FormItemsController)

import FormOptionController from "./form_option_controller"
application.register("form-option", FormOptionController)

import FormSelectionController from "./form_selection_controller"
application.register("form-selection", FormSelectionController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import HotkeyFocusController from "./hotkey_focus_controller"
application.register("hotkey-focus", HotkeyFocusController)

import LazyStreamController from "./lazy_stream_controller"
application.register("lazy-stream", LazyStreamController)

import LinkController from "./link_controller"
application.register("link", LinkController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ParticipantController from "./participant_controller"
application.register("participant", ParticipantController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import NotionController from "./notion_controller"
application.register("notion", NotionController)

import PaymentRequests__FormController from "./payment_requests/form_controller"
application.register("payment-requests--form", PaymentRequests__FormController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import ProductsMapperController from "./products_mapper_controller"
application.register("products-mapper", ProductsMapperController)

import RequisitFormController from "./requisit_form_controller"
application.register("requisit-form", RequisitFormController)

import SmsMessageController from "./sms_message_controller"
application.register("sms-message", SmsMessageController)

import System__SpFieldsController from "./system/sp_fields_controller"
application.register("system--sp-fields", System__SpFieldsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TagsFieldController from "./tags_field_controller"
application.register("tags-field", TagsFieldController)

import UploadImageController from "./upload_image_controller"
application.register("upload-image", UploadImageController)

import UserPermissions__PermissionsSelectionController from "./user_permissions/permissions_selection_controller"
application.register("user-permissions--permissions-selection", UserPermissions__PermissionsSelectionController)

import XdeliveryMapController from "./xdelivery_map_controller"
application.register("xdelivery-map", XdeliveryMapController)
